module.exports = __webpack_public_path__ + "static/media/scan&pay.8857dcc6.mp4";